import React from 'react'
import { FacetSelect } from '../BaseComponents/FacetSelect'
import ExperienceFacetSection from './ExperienceFacetSection'

const VirtualFacetSection: React.FC = () => (
  <>
    <ExperienceFacetSection />
    <FacetSelect
      source="virtualCategoryFacet"
      facetCategory="productFilter"
      filterGroup="VirtualCategory"
    />
  </>
)

export default VirtualFacetSection
